import React, { useCallback, useEffect, useState } from "react";
import { apiClient } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";

const chf = (v) => Number(v || 0).toLocaleString("de-CH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function AdminAiStatementsList({ ym, refreshKey }) {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(null);
  const [billing, setBilling] = useState(null);

  const load = useCallback(async () => {
    try {
      const [s, b] = await Promise.all([apiClient.get(`/admin/ai-usage/statements?year_month=${ym}`), apiClient.get("/admin/ai-billing")]);
      setItems(s.data || []); setBilling(b.data);
    } catch { /* ignore */ }
  }, [ym]);
  useEffect(() => { load(); }, [load, refreshKey]);
  useEffect(() => { window.addEventListener("ai-billing-changed", load); return () => window.removeEventListener("ai-billing-changed", load); }, [load]);

  const invoice = async (st) => {
    if (!window.confirm(`Rechnung an «${st.name}» über CHF ${chf(st.amount_chf)} in «${billing?.billing_company_name}» als Entwurf anlegen?`)) return;
    setBusy(st.id);
    try {
      const r = await apiClient.post(`/admin/ai-usage/statements/${st.id}/invoice`);
      toast.success(`Rechnung ${r.data.invoice_number} (Entwurf, CHF ${chf(r.data.total)}) in ${r.data.billing_company_name} angelegt`);
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Rechnung konnte nicht erstellt werden"); }
    finally { setBusy(null); }
  };

  if (!items.length) return null;
  return (
    <div className="mt-3" data-testid="ai-statements-list">
      <div className="text-[11px] font-medium text-slate-600 mb-1">Übernommene Positionen {ym} · Betreiber-Firma: <b>{billing?.billing_company_name || "noch nicht gewählt (unten festlegen)"}</b></div>
      <table className="w-full text-xs">
        <thead><tr className="text-left text-slate-500 border-b border-slate-100"><th className="py-1">Mandant</th><th className="text-right">Betrag CHF</th><th>Status</th><th></th></tr></thead>
        <tbody>
          {items.map((s) => (
            <tr key={s.id} className="border-b border-slate-50" data-testid={`ai-statement-row-${s.company_id}`}>
              <td className="py-1">{s.name}</td>
              <td className="text-right font-medium">{chf(s.amount_chf)}</td>
              <td>{s.status === "verrechnet" ? <span className="text-emerald-700" data-testid={`ai-statement-invoiced-${s.company_id}`}>verrechnet · {s.invoice_number}</span> : <span className="text-slate-500">offen</span>}</td>
              <td className="text-right">
                {s.status !== "verrechnet" && (
                  <Button size="sm" variant="outline" className="h-7 text-xs" disabled={busy === s.id || !billing?.billing_company_id} onClick={() => invoice(s)} data-testid={`ai-statement-invoice-${s.company_id}`}>
                    {busy === s.id ? <Loader2 className="w-3 h-3 animate-spin" /> : <FileText className="w-3 h-3 mr-1" />}Auf Rechnung
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
